import { connect } from 'react-redux';
import { RootState } from 'model/state';
import { Content } from 'components';
import { createStructuredSelector } from 'reselect';
import { selectIsContentLoading } from 'selectors/Common';

const mapStateToProps = createStructuredSelector<RootState, { isLoading: boolean }>({
  isLoading: selectIsContentLoading()
});

export default connect(mapStateToProps)(Content);
